import React, { Component } from 'react'
import { AppContext } from '@lightspeed-invoicing/core-client/frontend'
import Select from 'react-select'
const provinces = require("provinces")

class StateSelect extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            options: [],
            selectedOption: this.props.value || null,
            countryCode: this.props.countryCode,
            disabled: this.props.disabled || false,
        }

        const defaultCallback = () => { }
        this.name = this.props.name
        this.placeholder = this.props.placeholder
        this.onChange = this.props.onChange || defaultCallback
        this.handleChange = this.handleChange.bind(this)
    }

    componentDidMount() {
        this.loadProvinces()
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            selectedOption: nextProps.value || null,
            countryCode: nextProps.countryCode,
            disabled: nextProps.disabled || false,
        }, () => this.loadProvinces())
    }

    loadProvinces() {
        var emptyOption = [{
            value: "",
            label: "-",
        }]
        let provincesToDisplay = provinces.filter(p => p.country === this.state.countryCode && p.locale === AppContext.getLocale().getLanguageWithoutRegionCode())
        if (provincesToDisplay.length === 0) {
            provincesToDisplay = provinces.filter(p => p.country === this.state.countryCode)
        }
        var provincesDropdown = emptyOption.concat(provincesToDisplay).map(p => {
            return {
                value: p.short || p.name,
                label: p.name,
            }
        })

        this.setState({
            options: provincesDropdown
        })
    }

    handleChange(selectedOption) {
        this.setState({
            selectedOption: selectedOption
        }, () => {
            var localizedStateName = ''
            var stateCode = ''
            if (selectedOption && selectedOption.value !== '') {
                localizedStateName = selectedOption.label
                stateCode = selectedOption.value
            }
            this.onChange(localizedStateName, stateCode)
        });
    }

    render() {
        return (
            <Select
                name={this.name}
                value={this.state.selectedOption}
                onChange={this.handleChange}
                options={this.state.options}
                disabled={this.state.disabled}
            />
        )
    }
}

export default StateSelect





// WEBPACK FOOTER //
// ./src/common/contact/stateselector.component.jsx